export default "__VITE_ASSET__D0WwA1UD__"